module.exports = __webpack_public_path__ + "03_veryshort_beige.168c2b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_veryshort_beige.png
// module id = xZ7W
// module chunks = 0